import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_CUSTOMER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

const CustomerActionsMenu = ({ customer }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { hasEInvoicePermission } = usePermissions();
  const { customers: c } = useTranslatedMessages();
  const actions = c?.actions ?? {};
  const accessDeniedMessage = useAccessDeniedMessage();
  const canUpdate = hasEInvoicePermission(UPDATE_CUSTOMER);

  const onClickingDetails = () => {
    handleClose();
    navigate('/customers/:id'.replace(':id', customer.profile_id));
  };

  const onClickingEdit = () => {
    if (!canUpdate) {
      return;
    }
    handleClose();
    navigate('/customers/:id/edit'.replace(':id', customer.profile_id));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton data-testid="action-icon-button" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <MenuItem data-testid="details" key="details" onClick={onClickingDetails}>
          {actions.details ?? 'Details'}
        </MenuItem>
        <PermissionDeniedWrapper show={!canUpdate} title={accessDeniedMessage} fullWidth>
          <MenuItem data-testid="edit" key="edit" disabled={!canUpdate} onClick={onClickingEdit}>
            {actions.edit ?? 'Edit'}
          </MenuItem>
        </PermissionDeniedWrapper>
      </Menu>
    </>
  );
};

export default CustomerActionsMenu;
